export enum ToastType {
  neutral = "neutral",
  success = "success",
  info = "info",
  warning = "warning",
  error = "error"
}
